import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="acceptance"
export default class extends Controller {
  static targets = ["input", "button"]

  onClick(event) {
    if (!this.inputTarget.checked) {
      event.preventDefault()
    }
  }

  toggle() {
    if (this.inputTarget.checked) {
      this.buttonTarget.classList.remove("disabled")
    } else {
      this.buttonTarget.classList.add("disabled")
    }
  }
}
